// extracted by mini-css-extract-plugin
module.exports = {"google-map-holder":"Map_google-map-holder__BPsfV","active":"Map_active__3CQzK","infoBox":"Map_infoBox__DEb3d","visitWebsiteInfoBox":"Map_visitWebsiteInfoBox__5SLXF"};